<ion-card>
  <ion-card-header>
    <ion-card-title>Kimenő levelezés</ion-card-title>
    <ion-card-subtitle>SMTP-kapcsolat és feladó – telepítés nélkül állítható</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <ng-container *ngIf="!toltodik">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        Innen megy ki minden levél: az ebédrendelés a beszállítónak, az értesítők, a
        számlák és a bizonylatok. Ha az <b>S/MIME aláíró tanúsítvány</b> ki van jelölve a
        Tanúsítványkezelésben, a levelek <b>aláírva</b> mennek – azt itt nem kell külön
        beállítani.
      </ion-note>

      <!-- A NÉMA CSAPDA: érvénytelen aláírással a küldés hibátlan, a levél mégsem
           érkezik meg, mert a fogadó oldal karanténba teszi. -->
      <ion-note color="danger" *ngIf="figyelmeztetes" style="display:block;margin-bottom:14px">
        <b>Figyelem – ettől nem érkezhet meg a levél.</b><br>{{ figyelmeztetes }}
      </ion-note>

      <ion-note color="medium" *ngIf="smime?.betoltve" style="display:block;margin-bottom:14px;font-size:12px">
        A kimenő levelek <b>S/MIME aláírással</b> mennek
        <span *ngIf="smime.email">({{ smime.email }}</span><span *ngIf="smime.email && smime.ervenyes_ig">,
        érvényes: {{ smime.ervenyes_ig | date:'yyyy. MM. dd.' }}</span><span *ngIf="smime.email">)</span>.
        Ha nem kell, a Tanúsítványkezelésben vedd le az aláíró jelölést.
      </ion-note>

      <ion-note color="warning" *ngIf="forras === 'kornyezet'" style="display:block;margin-bottom:14px">
        A beállítás még nem az adatbázisból jön, hanem a telepítés környezeti
        változóiból. Mentéssel átveszed az irányítást.
      </ion-note>

      <ion-grid class="smtp-racs">
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Kiszolgáló (host)" label-placement="stacked" fill="outline"
                       placeholder="pl. levelezo.pelda.hu" [(ngModel)]="b.host"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input label="Port" label-placement="stacked" fill="outline" type="number"
                       [(ngModel)]="b.port"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-item lines="none" class="smtp-kapcsolo">
              <ion-toggle [(ngModel)]="b.secure" labelPlacement="start">Titkosított (SSL)</ion-toggle>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <ion-note color="medium" style="font-size:12px">
              <b>465</b> → kapcsold be (a kapcsolat titkosítottan indul).
              <b>587</b> vagy <b>25</b> → kapcsold ki: ilyenkor nyílt kapcsolattal indulunk,
              és <b>STARTTLS</b>-sel váltunk titkosítottra. Ahol felhasználó is van, ott ezt
              megköveteljük – ha a kiszolgáló nem tudja, inkább hibát kapsz, mintsem hogy a
              postafiók jelszava titkosítatlanul menjen át.
            </ion-note>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Felhasználó" label-placement="stacked" fill="outline"
                       placeholder="teljes e-mail cím" [(ngModel)]="b.felhasznalo"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Jelszó" label-placement="stacked" fill="outline" type="password"
                       [placeholder]="jelszoBeallitva ? 'beállítva – üresen hagyva marad' : 'nincs beállítva'"
                       [(ngModel)]="jelszo"></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Feladó" label-placement="stacked" fill="outline"
                       placeholder='pl. Iskola <titkarsag@pelda.hu>' [(ngModel)]="b.felado"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Válasz-cím (nem kötelező)" label-placement="stacked" fill="outline"
                       [(ngModel)]="b.valasz_cim"></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <ion-item lines="none" class="smtp-kapcsolo">
              <ion-toggle [(ngModel)]="b.engedelyezve" labelPlacement="start">
                Kimenő levelezés bekapcsolva
              </ion-toggle>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-note color="medium" style="display:block;margin:4px 0 14px">
        A <b>feladó</b> a legtöbb szolgáltatónál csak akkor működik, ha megegyezik a
        bejelentkezési fiókkal – idegen feladót a kiszolgáló visszautasít. Üresen hagyva
        a felhasználó címét használjuk.
      </ion-note>

      <div class="smtp-gombok">
        <ion-button color="primary" [disabled]="ment" (click)="mentes()">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          {{ ment ? 'Mentés…' : 'Mentés' }}
        </ion-button>
        <ion-button fill="outline" [disabled]="tesztFut" (click)="teszt()">
          <ion-icon slot="start" name="pulse-outline"></ion-icon>
          {{ tesztFut ? 'Ellenőrzés…' : 'Kapcsolat ellenőrzése' }}
        </ion-button>
      </div>

      <!-- A kapcsolat-ellenőrzés kevés: a bejelentkezést sok szolgáltató elfogadja,
           a küldést viszont visszautasítja. Ez a gomb végigmegy a valódi úton. -->
      <div class="smtp-proba">
        <ion-input label="Próbalevél címzettje" label-placement="stacked" fill="outline"
                   placeholder="valaki@pelda.hu" [(ngModel)]="probaCim"></ion-input>
        <ion-button fill="outline" [disabled]="probaFut || !probaCim" (click)="proba()">
          <ion-icon slot="start" name="send-outline"></ion-icon>
          {{ probaFut ? 'Küldés…' : 'Próbalevél küldése' }}
        </ion-button>
      </div>

      <ion-note *ngIf="eredmeny" [color]="eredmeny.ok ? 'success' : 'danger'"
                style="display:block;margin-top:12px">
        <b>{{ eredmeny.ok ? 'Rendben.' : 'Nem sikerült.' }}</b> {{ eredmeny.szoveg }}
      </ion-note>

      <!-- KÜLDÉSI NAPLÓ. „Sikeres volt, mégsem érkezett meg" – erre a mondatra csak
           akkor lehet válaszolni, ha eltesszük, mit mondott a kiszolgáló. -->
      <div class="smtp-naplo-fej">
        <ion-button size="small" fill="clear" (click)="naploValt()">
          <ion-icon slot="start" [name]="naploNyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
          Küldési napló
        </ion-button>
        <ion-button size="small" fill="clear" *ngIf="naploNyitva" [disabled]="naploFut" (click)="naploBetolt()">
          <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
        </ion-button>
      </div>

      <div *ngIf="naploNyitva" class="smtp-naplo">
        <div *ngIf="naploFut"><ion-spinner name="dots"></ion-spinner></div>
        <ion-note color="medium" *ngIf="!naploFut && !naplo.length" style="display:block;font-size:12px">
          Még nem ment ki levél ebből a rendszerből.
        </ion-note>

        <ion-note color="medium" *ngIf="!naploFut && naplo.length" style="display:block;font-size:12px;margin-bottom:8px">
          Az <b>„átvette"</b> azt jelenti, hogy a levelet a kiszolgáló elfogadta – onnantól a
          kézbesítés rajta múlik. Ha ilyen sor mellett a címzett mégsem kapta meg, a levél
          <b>azonosítójával</b> a szolgáltató naplójában kell keresni: ott derül ki, hogy
          továbbment-e, karanténba került-e, vagy a fogadó rendszer dobta el.
        </ion-note>

        <div class="naplo-sor" *ngFor="let n of naplo">
          <div class="naplo-fej">
            <ion-chip [color]="naploSzin(n.statusz)" class="naplo-jel">{{ naploCimke(n.statusz) }}</ion-chip>
            <span class="naplo-ido">{{ n.mikor | date:'MM. dd. HH:mm:ss' }}</span>
            <span class="naplo-alairt" *ngIf="n.alairva">aláírt</span>
          </div>
          <div class="naplo-cim"><b>{{ n.targy || '(tárgy nélkül)' }}</b></div>
          <div class="naplo-adat">{{ n.felado }} → {{ n.cimzett }}</div>
          <div class="naplo-adat" *ngIf="n.elutasitva"><b>Visszautasítva:</b> {{ n.elutasitva }}</div>
          <div class="naplo-adat" *ngIf="n.valasz">Kiszolgáló válasza: {{ n.valasz }}</div>
          <div class="naplo-adat" *ngIf="n.message_id">Azonosító: <code>{{ n.message_id }}</code></div>
          <div class="naplo-adat naplo-hiba" *ngIf="n.hiba">{{ n.hiba }}</div>
        </div>
      </div>

      <ion-note color="medium" *ngIf="modositva" style="display:block;margin-top:14px;font-size:12px">
        Utoljára módosítva: {{ modositva | date:'yyyy. MM. dd. HH:mm' }}
      </ion-note>
    </ng-container>
  </ion-card-content>
</ion-card>
